<script setup>
import { computed, onMounted, ref, watch } from 'vue';

const props = defineProps({
    modelValue: {
        type: [String, Number],
        default: ''
    },
    inputId: {
        type: String,
        default: ''
    },
    label: {
        type: String,
        default: ''
    },
    text: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    marginTop: {
        type: String,
        default: '0'
    },
    marginBottom: {
        type: String,
        default: '0'
    },
    marginLeft: {
        type: String,
        default: '0'
    },
    marginRight: {
        type: String,
        default: '0'
    },
    labelRightmargin: {
        type: String,
        default: '2rem'
    },
    options: {
        type: Array,
        default: () => []
    },
    visible: {
        type: Boolean,
        default: true
    },
    readonly: {
        type: Boolean,
        default: false
    },
    errmsg: {
        type: String,
        default: ''
    },
    disabled: {
        type: Boolean,
        default: false
    },
    icon: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        default: ''
    },
    width: {
        type: String,
        default: 'auto'
    },
    bgcolor: {
        type: String,
        default: '#f1f1f1'
    },
    fontColor: {
        type: String,
        default: '#4b5563'
    },
    labelEmpty: {
        type: Boolean,
        default: false
    },
    align: {
        type: String,
        default: ''
    }
});

const emit = defineEmits(['update:modelValue', 'click']);
const ValidationMsg = ref('');
const errMessage = ref(props.errmsg);
const isReadonly = computed(() => props.readonly);
const isBgcolor = computed(() => props.bgcolor);
const isVisible = computed(() => props.visible);

onMounted(() => {});

const handleClick = () => {
    emit('click', 'click');
    ValidationMsg.value = '';
};

watch(
    () => props.errmsg,
    (newVal) => {
        ValidationMsg.value = newVal || '';
        errMessage.value = newVal || '';
    },
    { immediate: true, deep: true }
);

watch(
    () => props.modelValue,
    (newValue) => {
        emit('update:modelValue', newValue);
    },
    { immediate: true }
);
</script>

<template>
    <div
        v-if="isVisible"
        class="flex flex-col"
        :style="{
            marginTop: marginTop,
            marginBottom: marginBottom,
            marginLeft: marginLeft,
            marginRight: marginRight
        }"
    >
        <label v-if="!labelEmpty" :class="['label-font mb-1', required ? 'label-required' : 'text-black dark:text-gray-300']">
            {{ label }}
            <span v-if="ValidationMsg" class="validation-message">{{ ValidationMsg }}</span>
        </label>

        <div>
            <button :id="inputId" @click="handleClick" :disabled="disabled" :title="title" :class="[!ValidationMsg === false ? 'err-button' : '']" :style="{ width: width, backgroundColor: bgcolor, color: fontColor, float: align }">
                <i v-if="icon" :class="icon" class="mr-2"></i>
                <span>{{ text }}</span>
            </button>
        </div>
    </div>
</template>

<style scoped>
.label-font {
    font-family: 'SCoreDream600';
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    margin-bottom: 0.25rem;
    margin-left: 0.25rem;
    height: 1.3rem;
}

button {
    height: 3rem;
    font-family: 'SCoreDream500';
    font-size: 0.875rem;
    padding: 0.375rem 1rem;
    min-width: 6rem;
    /* max-width: 12rem; */
    /* gap: 0.25rem; */
    /* background-color: #b9bac0; */

    border-radius: 0.375rem;
    transition: all 300ms ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
}

.err-button {
    border: 1px solid #f87171;
}

button:hover {
    opacity: 0.8;
}

.validation-message {
    color: #f87171; /* red-500 */
    font-size: 0.75rem;
    margin-left: 0.5rem;
}
</style>
